import { httpClient } from 'api';
import { TodosResponse } from 'types/Todo';

export const todosApi = {
	getTodos: ({ membershipId, applicationRole }: any) =>
		httpClient.get<TodosResponse>(`todos/${membershipId}/${applicationRole}`),
};
